module.exports = __webpack_public_path__ + "static/rc-7-b44f47296341abc9eceea370c6847332.jpg";